import { gql } from '@apollo/client';

export const CREATE_VIBRATION_MONITOR = gql`
    mutation CreateVibrationMonitor($input: CreateVibrationMonitor!) {
        facility {
            process {
                createVibrationMonitor(input: $input) {
                    id
                }
            }
        }
    }
`;
